import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ReviseBookingForm.html?raw';
import ResourcePicker from '../../moreCore/UI/ResourcePicker/ResourcePicker';
import "../../moreCore/UI/ResourcePicker/ResourcePicker";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import TiBookingSummary from '../TransportIntermodal/BookingSummary';
import "../TransportIntermodal/BookingSummary";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import Toaster from '../../moreCore/UI/Toaster_TS/Toaster';
import { TiEntities, TiInterfaces } from "./TiTypes";
import TiMainRouteView from './Route/MainRouteView';
import TiRouteSectionsView from './Route/RouteSectionView';
import TiBookingView from './BookingView';
import { ToasterHelpers } from "../../more/Helpers";


 

interface OffloadingEntry { label: string, value: number };
class TiReviseBookingForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    bookingMode: "default" | "rebook" = "default";

    //slotpickerContainer_logistic: HTMLElement;
    //slotpickerContainer_route: HTMLElement;
    public section1_bookingFilter: HTMLElement;
    public section2_bookedSlotSelect: HTMLElement;
    public section2_innerContainer: HTMLElement;
    public section3_newRouteSectionSelect: HTMLElement;
    public section3_innerContainer: HTMLElement;
    //public sectionStep4: HTMLElement;
    public section4_Summary: HTMLElement;
    public section5_RevisionComplete: HTMLElement;

    dateFilterLabelsection2: HTMLElement;
    dateFilterLabelsection3: HTMLElement;
    


    inputOrderNo: HTMLInputElement;
    inputSlotStatus: MdsLax<InstanceType<typeof SearchSelect>>;
    inputRouteSection: MdsLax<InstanceType<typeof SearchSelect>>;
    inputDivision: MdsLax<InstanceType<typeof SearchSelect>>;
    sectionSlotResourcePicker: MdsLax<InstanceType<typeof ResourcePicker>>;
    alternateSlotResourcePicker: MdsLax<InstanceType<typeof ResourcePicker>>;
    bookingView: MdsLax<InstanceType<typeof TiBookingSummary>>;
    bookingRouteSlotsTable: MdsLax<InstanceType<typeof StaticTable>>;

    btnBook: HTMLButtonElement;
    btnRebook: HTMLButtonElement;
    btnReserve: HTMLButtonElement;
    btnCancel: HTMLButtonElement;
    btnLater: HTMLButtonElement;
    btnEarlier: HTMLButtonElement;
    btnLaterAlternateSlots: HTMLButtonElement;
    btnEarlierAlternateSlots: HTMLButtonElement;
    btnModeCancelOldSlot: HTMLButtonElement;
    btnModeResetOldSlot: HTMLButtonElement;

    progressBar: HTMLElement;
    sectionSlotResourcesContainer: HTMLElement;
    newRouteSectionContainer: HTMLElement;
    routeInfoContainer: HTMLElement;
    bookingInfoContainer: HTMLElement;
    oldSlotContainer: HTMLElement;
    newSlotContainer: HTMLElement;
    newRoute: HTMLElement;
    oldRoute: HTMLElement;
    summaryContainer: HTMLElement;
    bookingSummary: HTMLElement;
    bookingConfirmationContainer: HTMLElement;
    modeContainer: HTMLElement;

    private slotStatusID: string;
    private bookingID: string;
    private divisionID: string;
    private routeSectionID: string;
    private routeSectionSlotID: string;
    private newRouteSectionSlotID: string;
    private filterDateBookedSections: Date;
    private filterDateAlternateSlots: Date;
    private cancelOldSlots: boolean = true;

    private bookingsRegistry: Array<TiEntities.BookingEntityData> = [];
    private routeSectionSlotRegistry: Array<TiEntities.SectionTimeSlotEntity_Aliased> = [];
    private alternateRouteSectionSlotRegistry: Array<TiEntities.SectionTimeSlotEntity_Aliased> = [];
    private alternateMainRouteSlotsRegistry: Array<TiEntities.MainRouteTimeSlotEntity_Aliased> = [];
    private routeSectionRegistry: Array<{ ID: string, name: string }> = [];
    private divisionsRegistry: Array<{ ID: string, name_address: string }> = [];

    private selectedBooking: TiEntities.BookingEntityData = null;
    private selectedOldMainRouteSlot: TiEntities.MainRouteTimeSlotEntity_Aliased = null;
    private selectedOldSectionSlot: TiEntities.SectionTimeSlotEntity_Aliased = null;
    private selectedNewSectionSlot: TiEntities.SectionTimeSlotEntity_Aliased = null;

    s1_bookingFilter_Valid: boolean = false;
    //step1_Value: string;
    s1_bookingFilter_Summary: string;

    s2_bookedSlotSelect_Valid: boolean = false;
    //step2_Value: string;
    s2_bookedSlotSelect_Summary: string;

    s3_newTimeslotSelect_Valid: boolean = false;
    //step3_Value: string;
    s3_newTimeslotSelect_Summary: string;

    revisionCompleted: boolean = false;

    private previousFormdata: string;

    private formData: TiInterfaces.BookingRevisionFormData = null;

    private loadDivisions(): void {

        this.inputDivision.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/LoadDivisions";

        let data = {
            
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadDivisionsResponse),
            lang.hitch(this, this._onLoadDivisionsError),
            false // sync
        );
    }

    private _onLoadDivisionsResponse(response: Array<{ ID: string, name_address: string}>) {
        this.inputDivision.StandbyStop();
        let result = false;
        for (let entity of response) {
            if (entity.ID == this.divisionID) {
                result = true;
                break;
            }
        }

        if (result != true) {
            this.divisionID = null;
        }

        // kurze Überbrückung bis morecore wieder up to date:
        if (this.inputDivision["setSelectionListLEGACY"]) {
            this.inputDivision.setData(null, response, true);
        } else {
            (this.inputDivision["setData"] as any)(response, true);
        }
        this.inputDivision.setValue(this.divisionID);

        this.divisionsRegistry = response;
    }

    private _onLoadDivisionsError(error: more.requestErrorMessage) {
        this.inputDivision.StandbyStop();
        this.showMessage("loading divisions failed", error.Message, true);

        //alert(error.Message);

    }

    _setDivisionAttr(ID: string) {
        //this._onChange_InputDivision(ID);
        this.inputDivision.setValue(ID);
    }

    private _onChange_InputDivision(value: string) {
        //console.debug("_onChange_InputDivision", value);
        localStorage.setItem("Ti_DivisionID", value);
        this.divisionID = value;
        this.bookingID = null;
        this.routeSectionSlotID = null;

        this.UiModder.domClass.toggle(this.inputRouteSection.domNode, "w3-disabled", !this.divisionID);
        
        this.checkStep1();

        if (this.divisionID) {
            //this.inputTerminal.setValue(null);
            this.loadRouteSections();
        }

    }

    private loadRouteSections(): void {

        this.inputRouteSection.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/GetRouteSections";

        let data = {
            "divisionID": this.divisionID,
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadRouteSectionsResponse),
            lang.hitch(this, this._onLoadRouteSectionsError),
            false // sync
        );
    }

    private _onLoadRouteSectionsResponse(response: { routeSections: Array<{ name: string, ID: string }>, dateStepWidth: number }) {
        this.inputRouteSection.StandbyStop();

        this.routeSectionRegistry = response.routeSections;

        // kurze Überbrückung bis morecore wieder up to date:
        if (this.inputRouteSection["setSelectionListLEGACY"]) {
            this.inputRouteSection.setData(null, response.routeSections, true);
        } else {
            (this.inputRouteSection["setData"] as any)(response.routeSections, true);
        }

        this.dateStepWidth = response.dateStepWidth;
        let filterDate = new Date();
        filterDate.setHours(0, 0, 0, 0);
        this.filterDateBookedSections = filterDate;
        this.dateStepsBookedSections = 0;
        this.changeFilterDateBookedSections(0);

    }

    private _onLoadRouteSectionsError(error: more.requestErrorMessage) {
        this.inputRouteSection.StandbyStop();
        this.showMessage("error loading route section", error.Message, true);
    }

    private _onChange_InputRouteSection(value: string) {
        this.routeSectionID = value;
        this.routeSectionSlotID = null;
        this.newRouteSectionSlotID = null;
        this.bookingID = null;
        this.checkStep1();

        this.UiModder.domConstruct.empty(this.bookingInfoContainer);
        this.UiModder.domConstruct.empty(this.routeInfoContainer);
        this.UiModder.domConstruct.empty(this.sectionSlotResourcesContainer);

    }


    checkStep1() {

        this.inputRouteSection.setReadonly(this.divisionID == null);

        this.s1_bookingFilter_Valid = false;
        this.s1_bookingFilter_Summary = "";

        //console.debug("step1Data", this.terminalID, this.divisionID);

        if (this.routeSectionID && this.divisionID) {

            let divisionLabel = "";
            for (let division of this.divisionsRegistry) {
                if (division.ID = this.divisionID) {
                    divisionLabel = division.name_address;
                    break;
                }
            }
            
            let routeSectionLabel = "";
            for (let routeSection of this.routeSectionRegistry) {
                if (routeSection.ID == this.routeSectionID) {
                    routeSectionLabel = routeSection.name;
                    break;
                }

            }

            this.s1_bookingFilter_Valid = true;
            this.s1_bookingFilter_Summary = this.stringFormat("{0}<br>{1}", divisionLabel, routeSectionLabel);

            this.UiModder.domClass.toggle(this.section2_bookedSlotSelect, "w3-disabled", !this.s1_bookingFilter_Valid);

            if (this.s1_bookingFilter_Valid) {
                this.loadSectionRouteSlots();
            }

        }

        this.emit("changeStep1");

        this.checkStep2();

    }

    private loadSectionRouteSlots(): void {

        this.StandbyStart(this.section2_innerContainer, "bookedSlots");

        var url = window.appRoot + "TransportIntermodal/LoadBookedSectionSlotsForRevision";

        let data = {
            "divisionID": this.divisionID,
            "routeSectionID": this.routeSectionID,
            "filterDate": this.dateToLocalISOString(this.filterDateBookedSections)
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadBookedSectionSlotsResponse),
            lang.hitch(this, this._onLoadBookedSectionSlotsError),
            false // sync
        );
    }

    private _onLoadBookedSectionSlotsResponse(response: {
        resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
        bookings: Array<TiEntities.BookingEntityData>,
        routeSectionSlots: Array<TiEntities.SectionTimeSlotEntity_Aliased>
    }) {

        this.StandbyStop("bookedSlots");
        this.UiModder.domConstruct.empty(this.sectionSlotResourcesContainer);
        this.UiModder.domClass.remove(this.sectionSlotResourcesContainer, "w3-disabled");
        this.UiModder.domClass.add(this.routeInfoContainer, "w3-disabled");

        this.bookingsRegistry = response.bookings;
        this.routeSectionSlotRegistry = response.routeSectionSlots;

        this.sectionSlotResourcePicker = new ResourcePicker;
        response.resourcepickerData.labelEmptyGroupContent = true;
        this.sectionSlotResourcePicker.setConfiguration(response.resourcepickerData);
        this.sectionSlotResourcePicker.setBaseUnits(2, 1);
        //this.logisticResourcesPicker.setLayout(null, "fixedCentered");
        this.sectionSlotResourcePicker.setLayout(null, "fullwidth");
        
        this.sectionSlotResourcePicker.placeAt(this.sectionSlotResourcesContainer);

        this.sectionSlotResourcePicker.adjustHeightFactorToContent(3, 0.5);


        this.sectionSlotResourcePicker.setTooltipClickFct(lang.hitch(this, this._onClick_SectionSlotTooltip));

        on(this.sectionSlotResourcePicker, "change", lang.hitch(this, this._onChange_SectionSlot));
    }

    private _onLoadBookedSectionSlotsError(error: more.requestErrorMessage) {
        //alert(error.Message);
        this.showMessage("loading bookings failed", error.Message, true);

        this.StandbyStop("bookedSlots");
    }


    private _onClick_SectionSlotTooltip(resource: ResourcePicker.ResourceEntry, content: string) {
        // es kann beides daherkommen, also wenn das passende Entry gefunden ist mit return raus!
        if (content?.length > 17) {
            let dlg = new GenericDialog();
            dlg._setHeaderAttr(resource.label);
            dlg.setCloseOnEscape(true);
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);
            dlg.setCloseOnEnter(false);
            dlg._setContentAttr(content);

            dlg.show();
            return;
        }

        if (content) {
            let booking = this.getBookingByID(content);

            if (booking) {

                let bookingView = new TiBookingView();

                bookingView.setup(booking.ID, {
                    showMainRoute: false,
                    showTransportGoods: "noExpander",
                    showBookingFormConfirmation: false,
                    showSummary: "noExpander",
                    transportGoodsConfig: {
                        interactive: false,
                        showFreightOccupation: true
                    }
                },
                    booking
                );

                return;
            }
        }
    }


    private _onChange_SectionSlot(value: Array<string>) {
        if (value && value.length == 1) {
            this.routeSectionSlotID = value[0];
        } else {
            this.routeSectionSlotID = null;
        }

        this.newRouteSectionSlotID = null;
        this.bookingID = null;
        this.UiModder.domConstruct.empty(this.routeInfoContainer);
        this.UiModder.domConstruct.empty(this.bookingInfoContainer);


        this.checkStep2(true); 
    }

    private checkStep2(bConfirmSelection?: boolean) {

        this.s2_bookedSlotSelect_Valid = false;
        this.s2_bookedSlotSelect_Summary = "";

        this.UiModder.domClass.add(this.routeInfoContainer, "w3-disabled");
        
        if (this.routeSectionSlotID) {

            let slotLabel = "";
            let bookingLabel = "?";
            for (let slot of this.routeSectionSlotRegistry) {
                if (slot.ID == this.routeSectionSlotID) {
                    slotLabel = slot.sectionName;
                    
                    this.filterDateAlternateSlots = new Date(slot.date_start.valueOf());
                    this.dateStepsAlternateSlots = 0;
                    this.changeFilterDateAlternateSlots(0);

                    let booking = this.getBookingByID(slot.bookingID);

                    this.selectedBooking = booking;
                    this.selectedOldSectionSlot = slot;

                    if (booking) {
                        bookingLabel = this.stringFormat("{0} {1}", booking.orderNo, booking.mainRouteCode);
                        this.bookingID = booking.ID;
                        break;
                    }

                    break;
                }
            }
            

            this.s2_bookedSlotSelect_Valid = bConfirmSelection === true;
            this.s2_bookedSlotSelect_Summary = this.stringFormat("{0} ({1})", slotLabel, bookingLabel);

            if (this.s2_bookedSlotSelect_Valid ) this.loadBookingRevisionRoutes();
        }

        this.UiModder.domClass.toggle(this.section3_newRouteSectionSelect, "w3-disabled", !this.s2_bookedSlotSelect_Valid || !this.s1_bookingFilter_Valid );
        this.emit("changeStep2");

        this.checkStep3();
    }

    private loadBookingRevisionRoutes(): void {

        this.inputSlotStatus.setValue(null);

        this.StandbyStart(this.section3_innerContainer, "routes");

        var url = window.appRoot + "TransportIntermodal/LoadBookingRevisionRoutes";

        let data = {
            "bookingID": this.bookingID,
            "routeSectionID": this.routeSectionID,
            "sectionSlotID": this.routeSectionSlotID,
            "filterDate": this.dateToLocalISOString(this.filterDateBookedSections)
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadBookingRevisionRoutesResponse),
            lang.hitch(this, this._onLoadBookingRevisionRoutesError),
            false // sync
        );
    }

    private getBookingByID(id: string): TiEntities.BookingEntityData {
        for (let booking of this.bookingsRegistry) {
            if (booking.ID == id) {
                return booking;
            }
        }

        return null;
    }

    private _onLoadBookingRevisionRoutesResponse(response: {
        selectedProblemSlot: TiEntities.SectionTimeSlotEntity_Aliased,
        mainRouteData: TiEntities.MainRouteTimeSlotEntity_Aliased,
        statusList: Array<{ name: string, ID: string, coloration: more.EntityAPIColor, sorting: number }>,
        preselectedStatusID: string
    }) {

        this.StandbyStop("routes");

        this.UiModder.domConstruct.empty(this.routeInfoContainer);
        this.UiModder.domConstruct.empty(this.bookingInfoContainer);

        if (!response) {
            return;
        }

        this.UiModder.domClass.remove(this.routeInfoContainer, "w3-disabled");
        this.UiModder.domClass.remove(this.bookingInfoContainer, "w3-disabled");

        // Status-Select befüllen
        // kurze Überbrückung bis morecore wieder up to date:
        if (this.inputSlotStatus["setSelectionListLEGACY"]) {
            this.inputSlotStatus.setData(null, response.statusList, true);
        } else {
            (this.inputSlotStatus["setData"] as any)(response.statusList, true);
        }
        this.inputSlotStatus.setValue(response.preselectedStatusID);


        // Übersicht Buchung vorbereiten
        let booking = this.getBookingByID(this.bookingID);
        let bookingView = new TiBookingSummary();
        let minimalBooking: TiEntities.BookingEntityData = {
            ...booking
        }
        bookingView.makeCompact(true);
        //minimalBooking.route = null;
        minimalBooking.offloading = null;
        minimalBooking.warnings = [];
        minimalBooking.status = null;

        bookingView.setData(minimalBooking);
        bookingView.placeAt(this.bookingSummary, "only");

        this.selectedOldMainRouteSlot = response.mainRouteData;
        let sectionSlot = null;
        for (let sectionAss of response.mainRouteData.sectionSlotAssignments) {
            let section = sectionAss.sectionSlot;
            if (section.ID == this.routeSectionSlotID) {
                sectionSlot = section;
                break;
            }
        }
        this.selectedOldSectionSlot = sectionSlot;

        this.createMainRouteOverview(this.routeInfoContainer, response.mainRouteData, this.routeSectionSlotID);
    }


    //private createSlotInfoContainer(data: any): HTMLElement {

    //    let container = this.UiModder.domConstruct.create("div", { className: "slotInfoContainer round" });

    //    this.UiModder.domClass.add(container, data.Classname);

    //    if (data.Classname == "section_main_route_timeslot") {
    //        let sectionSlot = <TransportIntermodal.SectionTimeSlotEntity_Aliased>data;

    //        let topRow = this.UiModder.domConstruct.create("div", { className: "topRow flex_row_center nowrap" }, container);

    //        if (sectionSlot.transportTypeIcon) {
    //            let icon = this.createFontawesomeIcon(sectionSlot.transportTypeIcon);
    //            this.UiModder.domConstruct.place(icon, topRow);
    //            this.UiModder.domClass.add(icon, "paddingY paddingSmallRight");
    //        }


    //        this.UiModder.domConstruct.create("div", { className: "title flex_cell_rest", "innerHTML": sectionSlot.sectionName }, topRow);
    //        this.UiModder.domConstruct.create("div", { className: "description", "innerHTML": sectionSlot.name }, container);

    //    }

    //    else if (data.Classname == "main_route_timeslot") {
    //        let mainRouteSlot = <TransportIntermodal.MainRouteTimeSlotEntity_Aliased>data;

    //        this.UiModder.domConstruct.create("div", { className: "title", "innerHTML": mainRouteSlot.mainRouteName }, container);
    //        this.UiModder.domConstruct.create("div", { className: "description", "innerHTML": mainRouteSlot.name }, container);

    //    }

    //    return container;
    //}

    private createMainRouteOverview(targetNode: HTMLElement, mainRouteSlot: TiEntities.MainRouteTimeSlotEntity_Aliased, targetSectionID?: string, highlightMode: "fadeAfterTarget" | "fadeBeforeTarget" = "fadeAfterTarget") {
        // ZEICHNEN: die Route insgesamt (Name, Teilstrecken-Slots)
        let overview = new TiMainRouteView();
        let sections = [];
        for (let assignment of mainRouteSlot.sectionSlotAssignments) {
            sections.push(assignment.sectionSlot);
        }
        overview.setData(mainRouteSlot,
            sections,
            {
            highlightSectionSlotID: targetSectionID,
            highlightMode: highlightMode,
            sectionsConfig: {
                enableBookingStatus: false,
                highlight: false
            }
        });
        overview.placeAt(targetNode);
    }

    private _onLoadBookingRevisionRoutesError(error: more.requestErrorMessage) {
        //alert(error.Message);
        this.showMessage("loading routes of booking failed", error.Message, true);

        this.StandbyStop("routes");
    }

    private _onChange_InputSlotStatus(value: string) {
        this.slotStatusID = value;
        this.serializeData();

        if (this.slotStatusID) {
            this.loadAlternateSectionSlots();
        }

        this.newRouteSectionSlotID = null;
    }


    private loadAlternateSectionSlots(): void {

        this.StandbyStart(this.newRouteSectionContainer, "altSlots");

        var url = window.appRoot + "TransportIntermodal/LoadAlternateSectionSlots";

        let data = {
            "bookingID": this.bookingID,
            "divisionID": this.divisionID,
            "routeSectionID": this.routeSectionID,
            "routeSectionSlotID": this.routeSectionSlotID,
            "slotStatusID": this.slotStatusID,
            "filterDate": this.dateToLocalISOString(this.filterDateAlternateSlots)
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadAlternateSectionSlotsResponse),
            lang.hitch(this, this._onLoadAlternateSectionSlotsError),
            false // sync
        );
    }

    private _onLoadAlternateSectionSlotsResponse(response: {
        resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
        routeSectionSlots: Array<TiEntities.SectionTimeSlotEntity_Aliased>,
        mainRouteSlots: Array<TiEntities.MainRouteTimeSlotEntity_Aliased>
    }) {
        this.StandbyStop("altSlots");
        
        this.alternateRouteSectionSlotRegistry = response.routeSectionSlots;
        this.alternateMainRouteSlotsRegistry = response.mainRouteSlots;

        this.UiModder.domConstruct.empty(this.newRouteSectionContainer);


        this.alternateSlotResourcePicker = new ResourcePicker;
        response.resourcepickerData.labelEmptyGroupContent = true;
        this.alternateSlotResourcePicker.setConfiguration(response.resourcepickerData);
        this.alternateSlotResourcePicker.setBaseUnits(2, 1, "50px");
        //this.logisticResourcesPicker.setLayout(null, "fixedCentered");
        this.alternateSlotResourcePicker.setLayout(null, "fullwidth");

        this.alternateSlotResourcePicker.placeAt(this.newRouteSectionContainer);

        this.alternateSlotResourcePicker.adjustHeightFactorToContent(3, 0.5);

        this.alternateSlotResourcePicker.setTooltipClickFct(lang.hitch(this, this._onClick_AlternateSlotTooltip));

        on(this.alternateSlotResourcePicker, "change", lang.hitch(this, this._onChange_AlternateSectionSlot));
    }

    private _onLoadAlternateSectionSlotsError(error: more.requestErrorMessage) {
        this.showMessage("loading routes of booking failed", error.Message, true);

        this.StandbyStop("altSlots");

    }

    private _onClick_AlternateSlotTooltip(resource: ResourcePicker.ResourceEntry, content: string) {
        let targetID = resource.value;

        if (content.length == 17) {
            targetID = content;
        }
        let mainRoute: TiEntities.MainRouteTimeSlotEntity_Aliased = null;
        for (let slot of this.alternateRouteSectionSlotRegistry) {
            if (slot.ID == targetID) {
                for (let route of this.alternateMainRouteSlotsRegistry) {
                    if (route.ID == slot.mainRouteSlotID) {
                        mainRoute = route;
                        break;
                    }
                }

                break;
            }
        }

        if (mainRoute) {
            let dlg = new GenericDialog();
            dlg._setHeaderAttr(mainRoute.name);
            dlg.setCloseOnEscape(true);
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);
            dlg.setCloseOnEnter(false);

                
            let routeNode = this.UiModder.domConstruct.create("div", { className: "TibookingForm"});
            this.createMainRouteOverview(routeNode, mainRoute, targetID, "fadeBeforeTarget");

            dlg.addNodeToContent(routeNode);
            dlg.show();
        }
    }

    private _onChange_AlternateSectionSlot(value: Array<string>) {
        if (value && value.length == 1) {
            this.newRouteSectionSlotID = value[0];
        } else {
            this.newRouteSectionSlotID = null;
        }

        this.checkStep3();

        
    }

    private checkStep3() {


        this.s3_newTimeslotSelect_Valid = false;
        this.s3_newTimeslotSelect_Summary = "";
        this.selectedNewSectionSlot = null;

        if (this.newRouteSectionSlotID) {
            this.s3_newTimeslotSelect_Valid = true;

            let slotLabel = "?";

            for (let slot of this.alternateRouteSectionSlotRegistry) {
                if (slot.ID == this.newRouteSectionSlotID) {
                    slotLabel = slot.name;
                    this.selectedNewSectionSlot = slot;
                    break;
                }
            }

            this.s3_newTimeslotSelect_Summary = slotLabel;            
        }

        this.UiModder.domClass.toggle(this.section4_Summary, "w3-hide w3-disabled", !this.s3_newTimeslotSelect_Valid || !this.s2_bookedSlotSelect_Valid || !this.s1_bookingFilter_Valid);

        this.emit("changeStep3");

        this.serializeData();

        this.createSummary();

        this.setModeButtonStyles();
    }

    private _onClick_ModeResetOldSlot(evt: MouseEvent) {
        if (this.cancelOldSlots === true) {
            this.cancelOldSlots = false;
            this.setModeButtonStyles();
            this.serializeData();
        }
    }

    private _onClick_ModeCancelOldSlot(evt: MouseEvent) {
        if (this.cancelOldSlots === false) {
            this.cancelOldSlots = true;
            this.setModeButtonStyles();
            this.serializeData();
        }
    }

    private setModeButtonStyles() {
        this.UiModder.domConstruct.empty(this.btnModeCancelOldSlot);
        this.UiModder.domConstruct.empty(this.btnModeResetOldSlot);

        this.UiModder.domClass.toggle(this.btnModeCancelOldSlot, "mds-hover-bright sD2", !this.cancelOldSlots);
        this.UiModder.domClass.toggle(this.btnModeCancelOldSlot, "accentOutline pD2 noInteraction", this.cancelOldSlots);

        this.UiModder.domClass.toggle(this.btnModeResetOldSlot, "mds-hover-bright sD2", this.cancelOldSlots);
        this.UiModder.domClass.toggle(this.btnModeResetOldSlot, "accentOutline pD2 noInteraction", !this.cancelOldSlots);

        let checkedIcon = this.createFontawesomeIcon("fas fa-check-circle", "&nbsp;");
        let uncheckedIcon = this.createFontawesomeIcon("far fa-circle", "&nbsp;");

        if (this.cancelOldSlots) {
            this.UiModder.domAttr.set(this.btnModeCancelOldSlot, "innerHTML", checkedIcon.outerHTML + this.translations["TiBooking__Revision_ModeCancelOldSlots"])
            this.UiModder.domAttr.set(this.btnModeResetOldSlot, "innerHTML", uncheckedIcon.outerHTML + this.translations["TiBooking__Revision_ModeResetOldSlots"])
        } else {
            this.UiModder.domAttr.set(this.btnModeCancelOldSlot, "innerHTML", uncheckedIcon.outerHTML + this.translations["TiBooking__Revision_ModeCancelOldSlots"])
            this.UiModder.domAttr.set(this.btnModeResetOldSlot, "innerHTML", checkedIcon.outerHTML + this.translations["TiBooking__Revision_ModeResetOldSlots"])
        }
    }

    private serializeData(resetDirty?: boolean) {
        //if (this.entityID) {
        //    return;
        //}

        this.formData = {
            newRouteSectionSlotID: this.newRouteSectionSlotID,
            divisionID: this.divisionID,
            bookingID: this.bookingID,
            slotStatusID: this.slotStatusID,
            cancelOldSlots: this.cancelOldSlots,
            oldRouteSectionSlotID: this.routeSectionSlotID
        };

        //console.debug("data serialized", this.formData);

        let currentFormdata = JSON.stringify(this.formData);

        if (currentFormdata != this.previousFormdata) {
            this.emit("change", this.formData);

            if (resetDirty === true) {
                this.previousFormdata = currentFormdata;
            }
        }

    }


    private _onClick_SaveRevision(evt: MouseEvent) {

        if (!this.s1_bookingFilter_Valid ||
            !this.s2_bookedSlotSelect_Valid ||
            !this.s3_newTimeslotSelect_Valid) {
            return;
        }

        this.UiModder.domClass.add(this.btnBook, "w3-disabled");

        this.confirmRevision();
    }


    private confirmRevision() {
        this.StandbyStart(this.section4_Summary); //WithText(this.translations["TiBooking__RevisionWaitingText"], this.section4_Summary);
        this.disableNode(this.domNode);

        var url = window.appRoot + "TransportIntermodal/ConfirmRevision";

        this.toaster.addToast(this.translations["TiBooking__RevisionWaitingText"], ToasterHelpers.ToasterIcons.hourglass, {
            timeout: 90 * 1000,
            ID: "revisionInProgress"
        });

        let data = this.formData;
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onConfirmRebookingResponse),
            lang.hitch(this, this._onConfirmRebookingError),
            false // sync
        );
    }

   

    private _onConfirmRebookingError(error: more.requestErrorMessage) {
        this.showMessage("rebooking failed", error.Message, true);
        this.StandbyStop();
        this.disableNode(this.domNode, false);
        this.disableNode(this.btnBook, false);

        this.toaster.removeToastById("revisionInProgress");
    }

    private _onConfirmRebookingResponse(response) {
        this.revisionCompleted = true;

        this.StandbyStop();
        this.disableNode(this.section4_Summary);
        this.hideNode(this.bookingConfirmationContainer);
        //this.UiModder.domClass.add(this.summaryContainer, "w3-disabled");

        this.UiModder.domClass.remove(this.section5_RevisionComplete, "w3-hide w3-disabled");
        this.disableNode(this.modeContainer);
        this.UiModder.domConstruct.place(this.summaryContainer, this.section5_RevisionComplete);

        this.toaster.removeToastById("revisionInProgress");

        this.emit("revisionCompleted");
    }



    showMessage(title: string, message: string, bIsError?: boolean, icon?: string) {

        let dlg = new GenericDialog();
        dlg._setHeaderAttr(title);
        dlg._setContentAttr(message);

        if (bIsError === true) {
            dlg._setTextIconAttr("fas fa-tired");
        }
        if (icon) {
            dlg._setTextIconAttr(icon);
        }

        dlg._setOkBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.setCloseOnEnter(false);

        dlg.show();

    }

    private createSlotInfoContainer(slot: TiEntities.SectionTimeSlotEntity_Aliased): HTMLElement {
        let view = new TiRouteSectionsView();
        let container = view.setData(slot);
        return view.domNode;
    }

    private createSummary() {
        let booking = this.selectedBooking;
        let oldSlot = this.selectedOldSectionSlot;
        let newSlot = this.selectedNewSectionSlot;

        //this.UiModder.domConstruct.empty(this.bookingSummary);
        this.UiModder.domConstruct.empty(this.oldSlotContainer);
        this.UiModder.domConstruct.empty(this.newSlotContainer);
        this.UiModder.domConstruct.empty(this.newRoute);
        this.UiModder.domConstruct.empty(this.oldRoute);

        if (!booking || !oldSlot || !newSlot) return;

        //this.UiModder.domConstruct.create("p", {
        //    innerHTML: booking.displayname
        //}, this.bookingSummary, "first");


        let div = this.createSlotInfoContainer(oldSlot);
        this.UiModder.domConstruct.place(div, this.oldSlotContainer);

        div = this.createSlotInfoContainer(newSlot);
        this.UiModder.domConstruct.place(div, this.newSlotContainer);

        this.createMainRouteOverview(this.oldRoute, this.selectedOldMainRouteSlot, oldSlot.ID);

        for (let mainRouteSlot of this.alternateMainRouteSlotsRegistry) {
            if (mainRouteSlot.ID == newSlot.mainRouteSlotID) {

                this.createMainRouteOverview(this.newRoute, mainRouteSlot, newSlot.ID, "fadeBeforeTarget")

                break;
            }
        }
    }


    private setFormData(data: TiInterfaces.BookingRevisionFormData) {
        
    }

    private _onClick_ChangeDateBackward(evt: MouseEvent) {
        this.changeFilterDateBookedSections(-1);
    }
    private _onClick_ChangeDateForward(evt: MouseEvent) {
        this.changeFilterDateBookedSections(1);
    }
    private _onClick_ChangeDateBackwardAlternateSlots(evt: MouseEvent) {
        this.changeFilterDateAlternateSlots(-1);
    }
    private _onClick_ChangeDateForwardAlternateSlots(evt: MouseEvent) {
        this.changeFilterDateAlternateSlots(1);
    }
    private dateStepsBookedSections: number = 0;
    private dateStepWidth: number = 8;
    private changeFilterDateBookedSections(steps: number = 0) {

        if (steps != 0 && typeof (steps) == "number") {
            this.dateStepsBookedSections = this.dateStepsBookedSections + steps;

            this.filterDateBookedSections.setHours(24 * this.dateStepWidth * steps);
        }

        this.routeSectionSlotID = null;
        this.checkStep2();


        let currentStart = this.dateToString(this.filterDateBookedSections,"EEE dd.MM.yyyy");
        let newDate = new Date(this.filterDateBookedSections.valueOf());
        newDate.setHours(24 * this.dateStepWidth * 1);
        let currentEnd = this.dateToString(newDate, "EEE dd.MM.yyyy");
        this.UiModder.domAttr.set(this.dateFilterLabelsection2, "innerHTML", this.stringFormat("{0} - {1}", currentStart, currentEnd));

        this.UiModder.domClass.toggle(this.btnLater, "w3-disabled", this.dateStepsBookedSections >= 12);
        this.UiModder.domClass.toggle(this.btnEarlier, "w3-disabled", this.dateStepsBookedSections <= 0);
        // Sonderrecht mit dem man in die Vergangenheit gehen kann:
        if (this.hasUserRole("TI_AllowPastSlotSelection")) this.UiModder.domClass.toggle(this.btnEarlier, "w3-disabled", this.dateStepsBookedSections <= -1);

        if (this.s1_bookingFilter_Valid === true) {
            this.delayFunction(lang.hitch(this, this.loadSectionRouteSlots));
        }
    }

    private dateStepsAlternateSlots: number = 0;
    private changeFilterDateAlternateSlots(steps: number = 0) {
        if (steps != 0 && typeof (steps) == "number") {

            this.dateStepsAlternateSlots = this.dateStepsAlternateSlots + steps;

            this.filterDateAlternateSlots.setHours(24 * this.dateStepWidth * steps);
        }

        this.newRouteSectionSlotID = null;
        this.checkStep3();


        let currentStart = this.dateToString(this.filterDateAlternateSlots);
        let newDate = new Date(this.filterDateAlternateSlots.valueOf());
        newDate.setHours(24 * this.dateStepWidth * 1);
        let currentEnd = this.dateToString(newDate);
        this.UiModder.domAttr.set(this.dateFilterLabelsection3, "innerHTML", this.stringFormat("{0} - {1}", currentStart, currentEnd));

        this.UiModder.domClass.toggle(this.btnLaterAlternateSlots, "w3-disabled", this.dateStepsAlternateSlots >= 12);
        this.UiModder.domClass.toggle(this.btnEarlierAlternateSlots, "w3-disabled", this.dateStepsAlternateSlots <= 0);
        // Sonderrecht mit dem man in die Vergangenheit gehen kann:
        if (this.hasUserRole("TI_AllowPastSlotSelection")) this.UiModder.domClass.toggle(this.btnEarlierAlternateSlots, "w3-disabled", this.dateStepsAlternateSlots <= -1);


        if (this.s2_bookedSlotSelect_Valid === true) {
            this.delayFunction(lang.hitch(this, this.loadAlternateSectionSlots));
        }
    }
    private delayFunction(fct: Function, delay: number = 600): void {
        if (this.delayLoadHandle != null) {
            clearTimeout(this.delayLoadHandle)
        }

        this.delayLoadHandle = setTimeout(fct, delay);
    }

    private delayLoadHandle: any = null;

    getData(): TiInterfaces.BookingRevisionFormData {
        return this.formData;
    }
  
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.useStandbyManager = true;
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    private toaster: MdsLax<InstanceType<typeof Toaster>> = null;
    startup() {
        super.startup.apply(this, arguments as any);
        this.toaster = new Toaster();


        if (this.formData) {

        }

        if (!this.divisionID) {
            this.routeSectionID = null;
            this.divisionID = localStorage.getItem("Ti_DivisionID");

            this.UiModder.domClass.remove(this.section1_bookingFilter, "w3-hide");
            this.loadDivisions();
        } else {
            this.loadRouteSections();
        }
    }
}

export default mdsWidget(TiReviseBookingForm);